import clsx from 'clsx';
import styles from './loadingPlayer.module.scss';

const LoadingPlayer = (props) => {
    const { className, numColumnsRow, text, showText, fons } = props;
    const stylesLoading = clsx({
        [styles.loadingPlayer]: true,
        [styles[`numColumns-${numColumnsRow}`]]: true,
        [styles[fons]]: true,
        [className]: !!className
    });
    return (
        <div className={stylesLoading}>
            <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100' className={styles.spinner}>
                <circle r={29} cx={50} cy={50} className={styles.bgSpinner} />
                <circle r={29} cx={50} cy={50} className={styles.bandaColor} />
            </svg>
            {showText && <div className={styles.textLoading}>{text}</div>}
        </div>
    );
};

LoadingPlayer.defaultProps = {
    numColumnsRow: 12,
    text: 'Carregant àudio',
    showText: true,
    fons: 'fonsContenidorNegre'
};

export default LoadingPlayer;
